// XY 模板特有的存儲鍵值
export const XY_STORAGE_KEYS = {
    HOME_STATISTICS: 'XYHome_Statistics',
    LUCKY7SLOT_MODAL_SEEN_HOME: 'lucky7SlotInfoModalSeen_XY_Home',
    LUCKY7SLOT_MODAL_SEEN_ACTIVITY: 'lucky7SlotInfoModalSeen_XY_Activity',
};

export default XY_STORAGE_KEYS;
